import React from "react";
import VersiyonBar from "./components/VersiyonBar";

export default function Version() {
  const customerVersionBar = (
    <p>
      2025 <span>&#169;</span> EK Panel | EK Dizayn Reklam Ajansı ve Bilişim Hiz. Dış. Tic. Ltd. Şti.
    </p>
  );

  const employeesVersionBar = (
    <p>
      2025 <span>&#169;</span> EK Cloud | EK Dizayn Reklam Ajansı ve Bilişim Hiz. Dış. Tic. Ltd. Şti.
    </p>
  );
  return (
    <VersiyonBar
      customerVersionBar={customerVersionBar}
      employeesVersionBar={employeesVersionBar}
    />
  );
}
